import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="portfolio-area-1 space overflow-hidden bg-smoke">
      <div className="container">
      <div className="row justify-content-center">
        {/* Título y Subtítulo */}
        <div className="col-lg-6">
          <div className="title-area text-center">
            <div className="row ">
            <Link to="www.lealchapaypintura.com">
                <img src="../assets/img/logo-black.svg" alt="LealChapayPintura.com" />
              </Link>
            </div>
            <br/>
            <span className="sub-title">Error 404</span>
            <h2 className="sec-title">Página No Encontrada</h2>
            <p>
              La página que está buscando no existe o fue movida. 
              Por favor, verifique la URL o regrese a la página principal.
            </p>
          </div>
        </div>
      </div>

        {/* Botón para volver al inicio */}
        <div className="row justify-content-center">

              <br/>
          <div className="col-lg-12 text-center">
            <Link to="/" className="th-btn" style={{ marginTop: "20px" }}>
              Volver al Inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
